import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Apirequests } from '../../utils/ApiRequests';
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
import SpinningLogo from '../../components/Spinner';
import CustomPageHeader from '../../components/CustomPageHeader';
import { downloadExcel } from '../../utils/DownloadXls';
import CommonLeadsTable from './CommonLeadsTable';
import CustomOffCanvas from '../../components/CustomOffCanvas';
import AddCommonLead from './AddCommonLead';
import moment from 'moment';
import BtnSpinner from '../../components/BtnSpinner';
import { Trash } from 'lucide-react';
import Pagination from '../../components/Pagination';

function SilvaDurgapur() {

    const [isOffCanvasOpen, setIsOffCanvasOpen] = useState({ state: false, name: "" });
    const [leads, setLeads] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState({ state: false, name: "" });
    const [currentPage, setCurrentPage] = useState(1);
    const [refresh, setRefresh] = useState(false);
    const [currentLead, setCurrentLead] = useState(null);
    const [deleteId, setdeleteId] = useState(null)

    const token = localStorage.getItem("token");

    const totalItems = leads?.length; // Total number of items
    const itemsPerPage = 20;

    const currentData = leads?.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const navigate = useNavigate();

    const handleRefresh = () => setRefresh(!refresh);

    const handleSearch = async () => {

        // console.log(searchTerm)
        if (!searchTerm) {
            return ErrorTost("Enter a key to serach")
        }

        if (currentPage !== 1) {
            setCurrentPage(1)
        }

        await getLeads(searchTerm)
    };


    const getLeads = async () => {
        setLoading({ state: true, name: "fetchleads" });
        try {
            const res = await Apirequests(
                `leads/get-leads-new?q=${searchTerm}`,
                "GET",
                {},
                {
                    Authorization: `Bearer ${token}`,
                    lead_type: "silvadurgapur"
                }
            );
            //   console.log(res,'course get res')
            if (res?.success) {
                setLeads(res.data);
            }
        } catch (error) {
            console.log(error, "leads res error.");
        }
        setLoading({ state: false, name: "" });
    };

    const deleteLead = async (id) => {
        setdeleteId(id);
        setLoading({ state: true, name: 'deletelead' })
        try {
            const deleteRes = await Apirequests(
                `leads/delete-lead/${id}`,
                "DELETE",
                { lead_type: "silvadurgapur" },
                {
                    Authorization: `Bearer ${token}`,
                }
            );
            // console.log(deleteRes,'delete lead');
            setRefresh(!refresh);
            if (deleteRes?.success) {
                SuccessTost(deleteRes?.message);
            } else {
                ErrorTost(deleteRes?.message);
            }
        } catch (error) {
            console.log(error, "delete course error");
            ErrorTost("Something went wrong, please try again later.")
        }
        setdeleteId(null);
        setLoading({ state: false, name: "" })
    };


    useEffect(() => {
        getLeads();
    }, [refresh, token]);


    if (loading.state && loading.name === "fetchleads") {
        return <div className='h-screen w-full flex items-center justify-center bg-[rgba(255,255,255,0.5)]'>
            <SpinningLogo />
        </div>
    }

    return (
        <div>

            <CustomPageHeader
                title={"Durgapur Silva Query Leads"}
                text={searchTerm}
                setText={setSearchTerm}
                handleSearch={handleSearch}
                onClick={() => setIsOffCanvasOpen({ state: true, name: "silvadurgapur" })}
                btnText={"Add Lead"}
                handleBackClick={() => navigate("/")}
                handleRefresh={handleRefresh}
                handleDownload={() => downloadExcel(leads, 'silvadurgapurcontacts')}
            />
            <main className="mx-auto py-6 sm:px-6 lg:px-8">
                <div className="px-4 py-6 sm:px-0">
                    <div className="overflow-x-auto">
                        <table className="min-w-full bg-white">
                            <thead className="bg-gray-50 text-center">
                                <tr>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Whatsapp Number</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Country</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Country Code</th>
                                     <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Query</th>

                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Created At</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200 text-center">
                                {leads?.map((lead) => (
                                    <tr key={lead?._id}>

                                        {/* <td className="px-6 py-4 whitespace-nowrap"><span className='text-indigo-600 cursor-pointer' onClick={() => { setIsOffCanvasOpen({ state: true, name: "viewcourse" }); setCurrentCourse(course) }}>{course?.course_id}</span></td> */}
                                        <td className="px-6 py-4 whitespace-nowrap">{lead?.name}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{lead?.email}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{lead?.whatsapp_number}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{lead?.notes?.country}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{lead?.notes?.country_code}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{lead?.notes?.query || "NA"}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{moment(lead?.createdAt).format("DD-MM-YY hh:mm a")}</td>
                                        <td className="px-6 py-4 flex gap-5 justify-center">
                                            {/* <button className='flex bg-indigo-400 rounded-lg px-3 py-2 items-center gap-1' onClick={() => { setIsOffCanvasOpen({ state: true, name: "editcourse" }); setCurrentCourse(course) }}>
                                            <Edit className='text-white' size={20} />
                                            <span className='text-white text-sm'>Edit</span>
                                        </button> */}
                                            <button className='flex bg-red-200 rounded-lg px-3 py-2 items-center gap-1' onClick={() => deleteLead(lead?._id)}>
                                                {
                                                    loading.state && loading.name === "deletelead" && deleteId === lead?._id ?
                                                        <BtnSpinner /> :
                                                        <>
                                                            <Trash className='text-red-700 text-sm' size={20} />
                                                            <span className='text-red-700 text-sm'>Delete</span>
                                                        </>
                                                }

                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                {leads?.length ?
                    <div className="flex gap-x-2 items-center justify-between">
                        <p>Total: {totalItems}</p>
                        <Pagination
                            page={currentPage}
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            onPageChange={handlePageChange}
                        />
                    </div> : null}
            </main>

            <CustomOffCanvas
                open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "silvadurgapur"}
                close={() => setIsOffCanvasOpen({ state: false, name: "" })}
                content={
                    <AddCommonLead
                        close={() => setIsOffCanvasOpen({ state: false, name: "" })}
                        setRefresh={setRefresh}
                        title={"Add Silva Durgapur Lead"}
                        leadUrl={"leads/contact-silva-durgapur "}
                    />
                }
            />
        </div>
    )
}

export default SilvaDurgapur